import { createFileRoute } from '@tanstack/react-router';
import { GeneralArea } from '@mews-commander/data-access';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings')({
    loader: async ({ params: { currentEnterpriseId }, context: { ensureQueryData } }) => {
        const { enterprises } = await ensureQueryData('generalEnterprises', 'getAll', {
            enterpriseIds: [currentEnterpriseId],
            application: GeneralArea.Commander,
        });

        return {
            title: () => enterprises[0]?.name,
        };
    },
    staticData: {
        owner: MewsTeam.Accounting,
        type: RouteType.Frontend,
    },
});
